import './AreaDrawBar.css';

/**
 * The bar over a map while an outline is being drawn (backlog #694): what to
 * do next, how many corners so far, Undo / Cancel / Done. The same look
 * (`.area-draw-bar.result`) carries the "N new letterboxes" answer afterwards.
 */
export default function AreaDrawBar({ count = 0, hint, onUndo, onCancel, onDone, doneLabel = 'Done' }) {
  const lead = count === 0
    ? 'Click the first corner of the area.'
    : count < 3
      ? `${count} corner${count === 1 ? '' : 's'} — keep clicking around the streets you want.`
      : `${count} corners.`;
  return (
    <div className="area-draw-bar" role="toolbar" aria-label="Draw an area">
      <p>
        <strong>{lead}</strong>{' '}
        {hint || 'Click the first corner or double-click to close it. Backspace undoes a corner, Esc cancels.'}
      </p>
      <div className="area-draw-actions">
        <button type="button" className="btn btn-sm btn-outline" onClick={onUndo} disabled={count === 0}>Undo</button>
        <button type="button" className="btn btn-sm btn-outline" onClick={onCancel}>Cancel</button>
        <button type="button" className="btn btn-sm btn-primary" onClick={onDone} disabled={count < 3}>{doneLabel}</button>
      </div>
    </div>
  );
}
